module.exports = __webpack_public_path__ + "static/feature_clients-6af435003e08199b851e6f1b35237c2b.png";